import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api.ts';
import {
  TPersonalDataApplicationsRevokeRequest,
  TPersonalDataApplicationsSubmit,
  TPersonalDataApplicationsSubmitRequest,
} from '../types.ts';
import { thunkErrorHandler } from '../../utils.ts';
import { TApplicationsPublicLinkResponse } from '~/store/types.ts';

export const createApplicationPersonalDataManager = createAsyncThunk<
  TApplicationsPublicLinkResponse,
  TPersonalDataApplicationsSubmitRequest
>('processingPersonal/manager', async ({ data }, { rejectWithValue }) => {
  try {
    const response = await api.post(`/personal-data/personal-data/applications`, data);
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const createApplicationPersonalDataClient = createAsyncThunk<
  TApplicationsPublicLinkResponse,
  TPersonalDataApplicationsSubmit
>('processingPersonal/clientSubmit', async (data, { rejectWithValue }) => {
  try {
    const response = await api.post(`/personal-data/public/personal-data/applications`, data);
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const createApplicationPersonalDataClientRevoke = createAsyncThunk<
  TApplicationsPublicLinkResponse,
  TPersonalDataApplicationsRevokeRequest
>('processingPersonal/clientRevoke', async (data, { rejectWithValue }) => {
  try {
    const response = await api.post(
      `/personal-data/public/personal-data/revoke/applications`,
      data
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
